// Copyright 2026. WebPros International GmbH. All rights reserved.

import { RootState as AdminState } from 'admin/core/store';
import { RootState as ClientState } from 'client/core/store';
import { DNSType } from 'common/api/resources/Settings';
import { LOADING_FLAGS } from 'common/modules/app/loadingFlags/constants';

export const isHighAvailabilityCrDisabled = (state: AdminState | ClientState) =>
    state.app.loadingFlags.has(LOADING_FLAGS.APP_SETTINGS_LOADED)
    && state.settings.high_availability_cr?.enabled === false;

// `mail` is absent from the settings payload for callers who may neither read app settings nor mass mail.
export const isMailDisabledInSettings = (state: AdminState | ClientState) =>
    state.app.loadingFlags.has(LOADING_FLAGS.APP_SETTINGS_LOADED)
    && state.settings.mail?.is_enabled === false;

export const isDnsIntegrationEnabled = (state: AdminState | ClientState) =>
    state.settings.dns.type !== DNSType.NULL;

export const getHostnameTemplate = (state: AdminState | ClientState) => {
    if (isDnsIntegrationEnabled(state) && shouldRegisterFqdnOnServerCreate(state)) {
        return state.settings.dns.server_hostname_template;
    }

    return null;
};

export const shouldRegisterFqdnOnServerCreate = (state: AdminState | ClientState) => {
    if (isDnsIntegrationEnabled(state)) {
        return state.settings.dns.register_fqdn_on_server_create;
    }

    return false;
};
